/**
 * WebSocket URL Helper fuer Browser und Native Apps (Capacitor)
 *
 * In der nativen App ist window.location.protocol = "capacitor://" und
 * window.location.host ist leer. Deshalb leiten wir die WebSocket-URL
 * immer aus REACT_APP_BACKEND_URL ab, wenn verfuegbar.
 */
export function getWebSocketBaseUrl() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  if (backendUrl) {
    const url = new URL(backendUrl);
    const protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${url.host}`;
  }

  // Fallback: Browser-Kontext (Development ohne .env)
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const host = window.location.host.replace('3000', '5002');
  return `${protocol}//${host}`;
}
